import MainLayout from '../components/MainLayout';
import { withAuthentication } from '../utils/withAuthentication';
import TripEmptyState from '../components/TripEmptyState';
import Button from '../components/Button';
import { useRouter } from 'next/router';
import { useTranslation, initReactI18next } from "react-i18next";
import React, { useEffect } from 'react';
import { getOrganizationByExternalId } from '../api/organizations'
import { useSessionContext } from '../contexts/sessionContext';

export function Dashboard() {
  const { t } = useTranslation();
  const router = useRouter();
  const title = t('Start creating your first trip');
  const description = t('Any new trip you create will be displayed here.');


  return (
    <MainLayout>
      <div className={'mt-10'}>
        <TripEmptyState
          title={title}
          description={description}
          button={
            <Button primary className="mx-auto" onClick={() => router.push('/truck/trip')}>
              {t('New Trip')}
            </Button>
          }
        />
      </div>
    </MainLayout>
  );
}

export default withAuthentication()(Dashboard);
